module.exports = __webpack_public_path__ + "media/images/sp/stores/funabashi/access/chiba_funabashi_point1_5-bfe10f6cc89abe21bb88de7722bcb0a0.jpg";